import { FetchActions, createFetchActions, Document } from '@syncfab/machine'

export const ACCEPT_RFQ: FetchActions<{ id: string }, {}> = createFetchActions('ACCEPT_RFQ')
export const GET_ORDERS: FetchActions<{}, {}> = createFetchActions('GET_ORDERS')
export const GET_ORDER: FetchActions<{ id: string }, {}> = createFetchActions('GET_ORDER')
export const ADD_DOCUMENT_ORDER: FetchActions<{ id: string; document: Document }, { document: Document }> = createFetchActions('ADD_DOCUMENT_ORDER')
export const REMOVE_DOCUMENT_ORDER: FetchActions<{ id: string; documentId: string }, { documentId: string }> = createFetchActions('REMOVE_DOCUMENT_ORDER')

export const GET_PART_BY_TRACKID: FetchActions<{ id: string }, {}> = createFetchActions('GET_PART_BY_TRACKID')
